module.exports = __webpack_public_path__ + "static/media/Pic-0467.dbb9df9f.jpg";